/**
 * Direction-aware profit/loss for an open position.
 *
 * Buy  -> profit when price rises   : lastTradePrice - entryPrice
 * Sell -> profit when price falls   : entryPrice - lastTradePrice
 *
 * `entryPrice` is stored as a String on StockTag, so both inputs are coerced.
 * Rows without a real position (tag "Watch", or entryPrice 0) have no P&L and
 * return a neutral "-" label.
 */
const calculateProfitLoss = (tag, entryPrice, lastTradePrice) => {
  const entry = Number(entryPrice);
  const ltp = Number(lastTradePrice);
  const isPosition = tag === "Buy" || tag === "Sell";

  if (!isPosition || !entry || !ltp || isNaN(entry) || isNaN(ltp)) {
    return {
      points: null,
      percent: null,
      label: "-",
      isProfit: false,
      isNeutral: true,
    };
  }

  const points = tag === "Sell" ? entry - ltp : ltp - entry;
  const percent = (points / entry) * 100;
  const sign = points > 0 ? "+" : "";

  return {
    points,
    percent,
    label: `${sign}${points.toFixed(2)} (${sign}${percent.toFixed(2)}%)`,
    isProfit: points > 0,
    isNeutral: points === 0,
  };
};

export default calculateProfitLoss;
